'use client';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html suppressHydrationWarning>
      <head>
        <title>Kesalahan</title>
      </head>
      <body style={{ fontFamily: 'system-ui, sans-serif', padding: '2rem', textAlign: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>Terjadi kesalahan!</h2>
          <button 
            onClick={() => reset()}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#000',
              color: '#fff',
              borderRadius: '0.25rem',
              border: 'none',
              cursor: 'pointer'
            }}
            >
            Coba lagi
          </button>
        </div>
      </body>
    </html>
  );
}
